<script>
import FormModal from "@/components/form-modal.vue";
import Modal from "@/components/g-modal.vue";
import Field from "@/components/input-v.vue";
import MasterDetail from "@/components/master-detail.vue";
import { TipoParticipante } from "../shared/participants";
import moment from "moment";
import { mapGetters } from "vuex";
import { isNil } from "lodash";

export default {
  components: {
    FormModal,
    Field,
    MasterDetail,
    Modal
  },
  data() {
    return {
      batchModal: {
        data: {},
        opened: false
      },
      bpName: "",
      deleteModal: {
        data: {},
        opened: false
      },
      editModal: {
        data: {},
        opened: false
      },
      exportModal: {
        filename: "",
        opened: false
      },
      pageTitle: "Timesheets dos participantes",
      rows: [],
      endDate: null,
      startDate: null,
      opts: {
        atividades: [],
        participantes: [],
        statuses: [
          {
            id: "positivo",
            nome:
              '<i aria-hidden="true" class="v-icon notranslate mdi mdi-plus-circle theme--light" style="color: #e69138"></i>'
          },
          {
            id: "igual",
            nome:
              '<i aria-hidden="true" class="v-icon notranslate mdi mdi-pause-circle theme--light" style="color: #135153; transform: rotate(90deg)"></i>'
          },
          {
            id: "negativo",
            nome:
              '<i aria-hidden="true" class="v-icon notranslate mdi mdi-minus-circle theme--light" style="color: #EC4C47"></i>'
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters(["clientId"]),
    actionBarButtons() {
      const buttons = [
        {
          text: "Exportar",
          icon: "mdi-download-box-outline",
          align: "right",
          action: () => {
            this.exportModal.filename = `${this.bpName || "timesheets"}.xlsx`;
            this.exportModal.opened = true;
          }
        },
        {
          text: "Importar",
          icon: "mdi-upload-box-outline",
          align: "right",
          action: () => {
            this.$refs.inputFile?.click();
          }
        },
        {
          text: "Ver Business Plan",
          icon: "mdi-chart-timeline",
          action: () => {
            const id = this.$route.params.id;

            const routeData = this.$router.resolve({
              name: "ativacaoped-projetos-form-edicao",
              params: { id },
              query: { tab: "alocacao" }
            });

            window.open(routeData.href, "_blank");
          }
        }
      ];

      if (this.canCreate) {
        buttons.unshift({
          text: "Adicionar em lote",
          icon: "mdi-plus-box-multiple-outline",
          action: () => {
            this.batchModal.data = {};
            this.batchModal.opened = true;
          }
        });
      }

      return buttons;
    },
    batchFields() {
      return [
        {
          key: "participantes",
          name: "Participante",
          type: this.$fieldTypes.AUTOCOMPLETE_MULTIPLE,
          rel: { to: "participantes", key: "id", name: "label" },
          rules: [{ rule: "required" }]
        },
        {
          key: "competenciaIni",
          name: "Competência inicial",
          type: this.$fieldTypes.MONTH,
          rules: [{ rule: "required" }],
          maxDate: this.maxSelectableMonth,
          minDate: this.startDate,
          colSize: 6
        },
        {
          key: "competenciaFim",
          name: "Competência final",
          type: this.$fieldTypes.MONTH,
          rules: [{ rule: "required" }],
          maxDate: this.maxSelectableMonth,
          minDate: this.startDate,
          colSize: 6
        },
        {
          key: "percentual",
          name: "Percentual",
          rules: [{ rule: "required" }],
          type: this.$fieldTypes.NUMBER
        }
      ];
    },
    canCreate() {
      if (isNil(this.startDate)) {
        return false;
      }

      const startDate = moment(this.startDate, "YYYY-MM-DD");
      return moment().isSameOrAfter(startDate, 'month');
    },
    cols() {
      return [
        {
          key: "status",
          name: "Status",
          type: this.$fieldTypes.HTML,
          hideInform: true,
          width: 50,
          rel: { to: "statuses", key: "id", name: "nome" },
          sortable: false
        },
        {
          key: "participante_email",
          name: "E-mail",
          hideInform: true,
          type: this.$fieldTypes.TEXT,
          filterable: true
        },
        {
          key: "centro_custo",
          name: "Centro de Custo",
          hideInform: true,
          sortable: false,
          type: this.$fieldTypes.TEXT
        },
        {
          key: "participante_id",
          name: "Participante",
          type: this.$fieldTypes.AUTOCOMPLETE,
          rel: { to: "participantes", key: "id", name: "label" },
          rules: [{ rule: "required" }],
          hideInTable: true
        },
        {
          key: "competencia",
          name: "Competência",
          type: this.$fieldTypes.MONTH,
          rules: [{ rule: "required" }],
          maxDate: this.maxSelectableMonth,
          minDate: this.startDate,
          filterable: true,
          colSize: 6
        },
        {
          key: "percentual",
          name: "Percentual realizado",
          type: this.$fieldTypes.NUMBER,
          rules: [{ rule: "required" }],
          hideInTable: true,
          colSize: 6
        },
        {
          key: "projetado_percentual",
          name: "Budget %",
          hideInform: true,
          sortable: false,
          type: this.$fieldTypes.DOUBLE,
          align: 1
        },
        {
          key: "realizado_percentual",
          name: "Real %",
          hideInform: true,
          sortable: false,
          type: this.$fieldTypes.DOUBLE,
          align: 1
        },
        {
          key: "delta",
          name: "Delta ativ.",
          hideInform: true,
          sortable: false,
          type: this.$fieldTypes.DOUBLE,
          align: 1
        },
        {
          key: "custo_medio",
          name: "Custo Médio",
          hideInform: true,
          sortable: false,
          type: this.$fieldTypes.MONEY,
          align: 1
        },
        {
          key: "calibragem",
          name: "Calibragem %",
          hideInform: true,
          sortable: false,
          type: this.$fieldTypes.DOUBLE,
          align: 1
        },
        {
          key: "projetado_valor",
          name: "Valor Calculado",
          hideInform: true,
          sortable: false,
          type: this.$fieldTypes.MONEY,
          align: 1
        }
      ];
    },
    customResource() {
      const id = this.$route.params.id;
      const self = this;
      const resource = this.apiResource(
        `/v1/ativacaoped/${this.clientId}/business-plans/${id}/timesheets`
      );

      return {
        ...resource,
        async batchSave(data) {
          const {
            participantes,
            competenciaIni: ini,
            competenciaFim: fim,
            ...rest
          } = data;
          const start = moment(ini, "YYYY-MM");
          const end = moment(fim, "YYYY-MM");
          const length = Math.abs(end.diff(start, "months")) + 1;
          const competencias = Array.from({ length }, (_, i) =>
            moment(start)
              .add(i, "months")
              .format("YYYY-MM")
          );
          const realizados = participantes.reduce((acc, participante_id) => {
            const items = competencias.map(competencia => ({
              ...rest,
              competencia,
              participante_id
            }));
            return [...acc, ...items];
          }, []);
          const response = await resource.save({ realizados });
          return [realizados, response];
        },
        async delete(id) {
          let item = null;

          try {
            item = self.rows.find(row => row.id === id);

            if (!item) {
              throw new Error(
                `Não foi encontrado nenhum registro com id ${id} para exclusão.`
              );
            }
          } catch (error) {
            console.error(error, { error });
            throw new Error("Erro interno: não foi possível concluir a ação.");
          }

          const { realizado_id } = item;

          if (!realizado_id) {
            throw new Error(
              "ID inválido. Não é possível excluir uma alocação não realizada."
            );
          }

          const response = await resource.delete(realizado_id);
          return response;
        },
        async get(...args) {
          const response = await resource.get(...args);
          const data = response.data.map(row => ({
            ...row,
            // Participante vinculado sem projetado e sem realizado também vem na lista: a chave inclui participante e competência
            id: `${row.participante_id}-${row.competencia}-projetado${row.projetado_id}-realizado${row.realizado_id}`
          }));
          self.rows = data;

          return { ...response, data };
        },
        async save(data) {
          if (isNil(data)) {
            return Promise.reject("Data inválida.");
          }

          const realizados = Array.isArray(data) ? data : [data];
          return resource.save({ realizados });
        }
      };
    },
    editFields() {
      return this.cols
        .filter(({ hideInform }) => !hideInform)
        .map(col => ({ ...col, editable: col.key === "percentual" }));
    },
    fieldExport() {
      return {
        key: "filename",
        name: "Nome do arquivo",
        placeholder: "timesheet.xlsx",
        type: this.$fieldTypes.TEXT,
        rules: [{ rule: "required" }, { rule: "max", params: { size: 255 } }]
      };
    },
    maxSelectableMonth() {
      if (isNil(this.endDate)) {
        return null;
      }

      const today = moment();
      const endDate = moment(this.endDate, "YYYY-MM-DD");
      const target = today.isAfter(endDate, 'month') ? endDate : today;
      return target.format("YYYY-MM");
    }
  },
  created() {
    this.getBusinessPlanDates();
  },
  methods: {
    contextmenu(row, event, _, col) {
      // 100ms para garantir que qualquer fn chamada por contextmenu tenha efeito antes de renderizar o menu de contexto.
      setTimeout(() => {
        const menu = [
          {
            name: "Editar timesheet",
            cb: row => {
              // O formulário grava em "percentual" (payload do Realizado); a listagem traz o valor em "realizado_percentual"
              this.editModal.data = { ...row, percentual: row.realizado_percentual };
              this.editModal.opened = true;
            }
          },
          {
            name: "Excluir timesheet",
            disabled: !row.realizado_id,
            cb: row => {
              this.deleteModal.data = {
                ...row,
                get parsedCompetencia() {
                  if (this.competencia) {
                    return moment(this.competencia, "YYYY-MM").format(
                      "MM/YYYY"
                    );
                  }

                  return "";
                }
              };
              this.deleteModal.opened = true;
            }
          }
        ];

        this.showContext({
          left: event.clientX,
          top: event.clientY,
          val: row,
          col,
          menu
        });
      }, 100);
    },
    async doBatchSave(data, close) {
      try {
        const [body] = await this.customResource.batchSave(data);

        this.$notify({
          group: "geral",
          duration: 5000,
          type: "sucess",
          title: "Cadastro concluído.",
          text: `${body.length} registros criados com sucesso.`
        });
        this.$refs.masterDetail?.doLoad();

        if (close) {
          close();
        }
      } catch (error) {
        if (!error.isAxiosError) {
          this.notify(error);
        }
      }
    },
    async doDelete(closeFn) {
      try {
        await this.customResource.delete(this.deleteModal.data.id);
        this.deleteModal.data = {};
        this.deleteModal.opened = false;
        this.$refs.masterDetail?.doLoad();

        if (closeFn) {
          closeFn();
        }

        this.$notify({
          group: "geral",
          duration: 5000,
          type: "sucess",
          title: `Exclusão concluída`,
          text: `Timesheet excluído com sucesso.`
        });
      } catch (error) {
        if (!error.isAxiosError) {
          this.notify(error);
        }
      }
    },
    async doExport() {
      try {
        const resource = this.apiResource(
          `/v1/ativacaoped/${this.clientId}/exportacao`
        );
        const filename =
          this.exportModal.filename || `timesheet-${new Date().getTime()}.xlsx`;
        await resource.save({
          tipo: "timesheet",
          arquivo_nome: this.sanitizeFilename(filename),
          filtros: {
            businessPlanId: this.$route.params.id
          }
        });

        this.$notify({
          group: "geral",
          duration: 10000,
          type: "info",
          title: `Exportação em processamento!`,
          text: `Quando concluída, você vai ser notificada pelo sistema e o arquivo vai estar disponível na aba Memória de cálculo e Evidências do Business Plan.`
        });

        this.exportModal.opened = false;
      } catch (error) {
        if (!error.isAxiosError) {
          this.notify(error);
        }
      }
    },
    async doUpdate() {
      try {
        const data = this.editModal.data;
        await this.customResource.save(data, data.id);
        this.editModal.data = {};
        this.editModal.opened = false;
        this.$refs.masterDetail?.doLoad();
      } catch (error) {
        if (!error.isAxiosError) {
          this.notify(error);
        }
      }
    },
    async getBusinessPlanDates() {
      try {
        const id = this.$route.params.id;
        const resource = this.apiResource(
          `/v1/ativacaoped/${this.clientId}/business-plans/${id}`
        );
        const response = await resource.get();
        const { data_inicio, data_fim, nome, participantes } = response.data;
        this.bpName = nome;
        this.pageTitle = `Business Plan: ${nome} - Timesheets dos participantes`;
        this.startDate = data_inicio ?? null;
        this.endDate = data_fim ?? null;

        if (Array.isArray(participantes)) {
          this.opts.participantes = participantes
            .filter(
              ({ tipo_participante }) =>
                tipo_participante == TipoParticipante.COLABORADOR
            )
            .map(({ budget_key, email, matricula, nome, perfil, ...rest }) => {
              let label = "";

              if (matricula || nome) {
                label += `${matricula || "Sem matricula"} - ${nome ||
                  "Sem nome"}`;
              } else if (budget_key) {
                label += `${budget_key}`;
              } else if (perfil) {
                const { especialidade, senioridade } = perfil;
                label += `${senioridade ||
                  "Sem senioridade"} - ${especialidade || "Sem especialidade"}`;
              }

              if (label && email) {
                label += ` (${email})`;
              }

              if (!label) {
                label = " -- ";
              }

              return {
                ...rest,
                label
              };
            })
            .sort(({ label: a }, { label: b }) => a.localeCompare(b));
        }
      } catch (error) {
        if (!error.isAxiosError) {
          this.notify(error);
        }

        this.startDate = null;
        this.endDate = null;
        this.opts.participantes = [];
      }
    },
    async onInputChange(event) {
      const [file] = Array.from(event.target.files);
      const MAX_FILE_SIZE = 10; // 10 MegaBytes

      if (file.size > MAX_FILE_SIZE * 1024 * 1024) {
        this.notify({
          error: `O arquivo ${file.name} excedeu o limite de ${MAX_FILE_SIZE}MB e não foi importado.`
        });
        return;
      }

      try {
        this.$root.$emit("addLoadingProcess", "pedtimesheetimport");
        const api = this.api();
        const url = `/v1/ativacaoped/${this.clientId}/business-plans/importar`;
        const formData = new FormData();
        formData.append("arquivo", file);
        formData.append("tipo", "timesheet");

        await api.post(url, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        });

        this.$notify({
          group: "geral",
          duration: 5000,
          type: "sucess",
          title: "Importação concluída",
          text: `Dentro de instantes a listagem estará atualizada.`
        });
      } catch (error) {
        this.notify(error);
      } finally {
        this.$root.$emit("removeLoadingProcess", "pedtimesheetimport");
      }

      event.target.value = null; // Importante para poder voltar a anexar mais arquivos
    },
    sanitizeFilename(filename = "") {
      let safeName = filename
        .replace(/[\\\/:*?"<>|]/g, "") // Remove caracteres especiais
        .replace(/\s+/g, "-") // Remove espaços
        .replace(/[\.\s]+$/, "") // Remove pontos além do ponto da extensão
        .normalize("NFD") // Normaliza para separar o código dos acentos do código das letras
        .replace(/[\u0300-\u036f]/g, "") // Remove o código de todos os acentos
        .toLowerCase();

      if (!/\.xlsx$/i.test(safeName)) {
        safeName += ".xlsx";
      }

      return safeName;
    }
  },
  watch: {
    "batchModal.data": {
      deep: true,
      handler({ competenciaIni, competenciaFim }) {
        const ini = moment(competenciaIni, "YYYY-MM");
        const fim = moment(competenciaFim, "YYYY-MM");

        if (ini.isValid() && fim.isValid() && ini.isAfter(fim)) {
          this.batchModal.data.competenciaFim = competenciaIni;
          this.batchModal.data.competenciaIni = competenciaFim;
        }
      }
    }
  }
};
</script>

<template>
  <v-card :color="tableColor">
    <div class="title-row">
      <h4 class="mb-0">{{ pageTitle }}</h4>
    </div>

    <div v-if="!canCreate" class="d-flex align-center items-center ml-4">
      <v-icon left class="mr-2" style="color: #fbb900">
        mdi-alert-circle
      </v-icon>
      <span style="color: #ffffff; font-size: 16px">
        Atenção: Não é possível cadastro de valores realizados antes do começo do projeto.
      </span>
    </div>

    <MasterDetail
      ref="masterDetail"
      :actionBarButtons="actionBarButtons"
      :canDelete="false"
      :canEdit="false"
      :cols="cols"
      :customResource="customResource"
      disableContextMenu
      formTitle="Alocar horas"
      :hasExportCSV="false"
      :hasExportXLSX="false"
      :hasFilter="false"
      :hasNewButton="canCreate"
      :opts="opts"
      serverPagination
      @contextmenu="contextmenu"
    ></MasterDetail>

    <input
      ref="inputFile"
      accept=".xlsx"
      class="input-file"
      type="file"
      @change="onInputChange"
    />

    <Modal
      :opened.sync="deleteModal.opened"
      title="Confirmar exclusão"
      width="500"
    >
      <p>
        Você está removendo as horas lançadas para o colaborador
        <b>{{ deleteModal.data.participante_email }}</b> na competência
        <b>{{ deleteModal.data.parsedCompetencia }}</b> no BP
        <b>{{ deleteModal.data.business_plan_nome }}</b
        >, deseja continuar?
      </p>

      <template #buttons="{ close }">
        <v-spacer />

        <v-btn
          class="px-5 ml-3"
          color="secondary"
          depressed
          @click="close(false)"
        >
          Cancelar
        </v-btn>

        <v-btn
          class="px-5 ml-3"
          color="error"
          dark
          depressed
          @click="doDelete(close)"
        >
          Excluir
        </v-btn>
      </template>
    </Modal>

    <Modal
      :opened.sync="exportModal.opened"
      title="Exportar Timesheet"
      width="600px"
    >
      <p>O processamento do arquivo é feito de forma assíncrona pelo Teros.</p>
      <p>
        Informe o nome do arquivo e aguarde a notificação de que o mesmo já está
        disponível para download.
      </p>

      <Field v-model="exportModal.filename" :label="fieldExport" />

      <template #buttons>
        <v-spacer />

        <v-btn
          class="px-5 ml-3"
          color="secondary"
          depressed
          @click="exportModal.opened = false"
        >
          Cancelar
        </v-btn>

        <v-btn
          class="px-5 ml-3"
          color="primary"
          dark
          depressed
          @click="doExport"
        >
          Exportar
        </v-btn>
      </template>
    </Modal>

    <FormModal
      :cols="editFields"
      contentClass="edit-modal"
      :opened.sync="editModal.opened"
      :opts="opts"
      title="Alocar horas"
      titleIcon="mdi-pen-outline"
      :value.sync="editModal.data"
      @save="doUpdate"
    />

    <FormModal
      :cols="batchFields"
      :opened.sync="batchModal.opened"
      :opts="opts"
      title="Adicionar em lote"
      titleIcon="mdi-plus-box-multiple-outline"
      :value.sync="batchModal.data"
      @save="doBatchSave"
    />
  </v-card>
</template>

<style lang="scss" scoped>
.input-file {
  display: none;
}

.title-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.5rem 0 0 1.2rem;
}
</style>

<style lang="scss">
.v-dialog.edit-modal .v-input.v-input--is-readonly .v-input__slot {
  color: #cecece;
}

.v-dialog.edit-modal
  .v-input.v-input--is-readonly
  .v-input__slot
  .v-text-field__slot {
  color: #cecece;
}
</style>
